import { styled } from '@mui/material/styles';

export const MenuItem = styled('li')`
  display: flex;
  align-items: center;
  height: 2.8rem;
  gap: 8px;
  cursor: pointer;
  & svg {
    height: 1.3rem;
  }
  &:hover {
    background: ${({ theme }) => theme.colors.primary[5]};
  }
  padding: 0 8px;
`;
